import { Component } from '@angular/core';
import { membersuiteMembershipDuesProductEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Membership Dues Products') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitemembershipduesproduct-form',
    templateUrl: './membersuitemembershipduesproduct.form.component.html'
})
export class membersuiteMembershipDuesProductFormComponent extends BaseFormComponent {
    public record!: membersuiteMembershipDuesProductEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

